import { Injectable } from '@angular/core'
import { AppPaths } from '@ftr/routing-paths'
import { Observable, of } from 'rxjs'
import { getAccessNavItemsGroup } from '../access-nav-items'
import { REQUEST_NAV_ITEMS_GROUP } from '../request-nav-items'
import { SideNavGroup, SideNavItem } from '../side-nav-item'

@Injectable({
  providedIn: 'root',
})
export class PublicNavItemsProvider {
  provide(): Observable<{ navGroups: SideNavGroup[]; footerItems: SideNavItem[] }> {
    return of({
      navGroups: [REQUEST_NAV_ITEMS_GROUP, getAccessNavItemsGroup()],
      footerItems: [
        {
          type: 'LINK',
          icon: 'Gavel',
          title: 'Enter a Court System',
          path: [AppPaths.CourtSystem],
        },
      ],
    })
  }
}
